import { createAsyncThunkFromFetch } from 'src/store/utils';
import {
  CompanyMetricsResponse,
  MetricsQueryParams,
} from './companyMetrics.types';
import { getMetrics } from './companyMetrics.api';

export const fetchMetricsAction = createAsyncThunkFromFetch<
  CompanyMetricsResponse,
  {
    companyId: string;
    params?: MetricsQueryParams;
  }
>('companyMetrics/fetchMetrics', getMetrics);
